module.exports = __webpack_public_path__ + "img/imagem_conecta_control.6fbbe3a8.jpg";